import React, { useEffect, useState, useRef } from 'react';

import VideoPlayer from '../../../components/VideoPlayer';
import ImageSlider from '../../../components/ImageSlider';
import {
  insertContentsTimeLog,
  insertItemLog,
  insertMakeShopItemLog,
  insertSlideLog,
} from '../../../modules/NetworkFunction';
import ProductSlider from '../../../components/ProductSlider';

function ContentsPreviewV({
  videoUrl,
  slideList,
  btnColor,
  fontColor,
  font,
  btnBorderRadius,
  contentNo,
  detailPath,
  margin,
  shopMode,
  contentType,
}) {
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [imageSlider, setImageSlider] = useState();
  const [productSlider, setProductSlider] = useState();

  const timerId = useRef();
  const playerRef = useRef();
  const sliderRef = useRef();
  const buyBtnRef = useRef();

  useEffect(() => {
    timerId.current = setInterval(async () => {
      if (playing) {
        const time = await playerRef.current.getCurrentTime();
        setCurrentTime(Number.parseInt(time));

        if (time !== null && contentNo) {
          const params = `?contentsNo=${contentNo}&time=${time}`;
          insertContentsTimeLog(params);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timerId.current);
    };
  }, [playerRef, playing, timerId, contentNo]);

  useEffect(() => {
    const checkPlayer = () => {
      const time = currentTime;

      for (let i = 0; i < slideList.length; i++) {
        if (slideList[i].displayTime > time) {
          let index = i < 1 ? 0 : i - 1;
          setCurrentSlideIdx(index);
          break;
        } else if (i === slideList.length - 1) {
          setCurrentSlideIdx(i);
        }
      }
    };
    checkPlayer();
  }, [currentTime, slideList]);

  useEffect(() => {
    if (buyBtnRef.current) {
      buyBtnRef.current.style.setProperty('font-family', font, 'important');
    }
  }, [font]);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.handleChangeSlideIdx(currentSlideIdx);
    }
  }, [currentSlideIdx]);

  const itemClick = (idx) => {
    _setPage(slideList[idx], idx);
  };

  const _setPage = (slideItem, index) => {
    if (index !== currentSlideIdx) {
      playerRef.current.seekTo(slideItem.displayTime);
      setCurrentSlideIdx(index);
      setPlaying(true);
      if (contentNo) {
        insertSlideLog(`?slideNo=${slideItem.slideNo}`);
      }
    }
  };
  const handleBuyBtnClick = () => {
    console.log('contentspreview v buyBtn Click');

    console.log('detailPath', detailPath);
    console.log('-------------------');
    console.log('shopMode: ', shopMode);

    if (detailPath) {
      window.open(detailPath + slideList[currentSlideIdx].productNo, '_blank');
      if (shopMode === 'cafe24') {
        insertItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      } else {
        insertMakeShopItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      }
    }
  };

  // popup일 경우 체크
  const IsPopup = (style) => {
    return style.includes('팝업') || style.includes('popup');
  }

  // 세로인지 가로인지 체크
  const IsVertical = (style) => { 
    return style.includes('세로') || style.includes('v');
  }

  return (
    <>
      <div
        style={{
          position: IsPopup(contentType) ? 'absolute' : 'relative',
          width: '60%',
          height: '720px',
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 0px 11.6991px rgba(0, 0, 0, 0.25)',
          backgroundColor: '#ffffff',
          margin:
              IsPopup(contentType) && IsVertical(contentType)
              ? '100px auto 0'
              : IsPopup(contentType)
              ? '30px auto 0'
              : `${margin}px auto`,
          top: IsPopup(contentType) ? '50%' : 'unset',
          left: IsPopup(contentType) ? '50%' : 'unset',
          transform: IsPopup(contentType)
            ? 'translate(-50%, -50%)'
            : 'none',
        }}
      >
        <div
          className="video-wrapper-vertical"
          style={{ width: '100%', height: '35%', position: 'relative' }}
        >
          <VideoPlayer
            ref={playerRef}
            videoUrl={videoUrl}
            playing={playing}
            setPlaying={setPlaying}
            isMobile={false}
          />
        </div>
        <div
          className="slide-wrapper"
          style={{
            width: '100%',
            height: '35%',
            backgroundColor: '#f3f3f3',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          {slideList.length > 0 && (
            <ImageSlider
              slideList={slideList}
              ref={sliderRef}
              handleSlideClick={(idx) => {
                _setPage(slideList[idx], idx);
              }}
              setSlider={setImageSlider}
              syncSlider={productSlider}
            />
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '10%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '95%',
              height: '80%',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <button
              ref={buyBtnRef}
              style={{
                width: '100%',
                height: '100%',
                borderRadius: btnBorderRadius,
                marginRight: 5,
                backgroundColor: btnColor ?? '#000',
                color: fontColor,
                fontWeight: 'bold',
                fontSize: 23,
              }}
              onClick={handleBuyBtnClick}
            >
              구매하기
            </button>
          </div>
        </div>
        <div
          style={{
            width: '100%',
            height: '20%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <p
            style={{
              fontWeight: 'bold',
              marginLeft: 15,
              fontFamily: font,
            }}
          >
            영상 속 다른 상품
          </p>
          <div style={{ display: 'flex', flexDirection: 'row', height: '90%'}}>
            <ProductSlider
              slideList={slideList}
              currentSlideIdx={currentSlideIdx}
              itemClick={itemClick}
              btnColor={btnColor}
              fontColor={fontColor}
              font={font}
              setSlider={setProductSlider}
              syncSlider={imageSlider}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ContentsPreviewV;
